import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderFormScreen } from '@/features/sales-orders/order-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating a sales order (plan screen 3, create mode).
 *
 * The grant guard is presentation only. The API enforces
 * `sales_order.create` on POST /sales/sales-orders, so a stale grant still
 * 403s server-side; this keeps a user without it out of a screen they cannot
 * use.
 */
export const Route = createFileRoute('/_authenticated/sales/orders/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'sales_order.create')) {
      throw redirect({ to: '/sales/orders' })
    }
  },
  component: OrderFormScreen,
})
